import {Pipe, PipeTransform} from '@angular/core';
import {GroupByValuesPipe, PropertyQuery} from "common-shared";
import {SpecLineModel} from "../../properties/models/spec-line.model";

@Pipe({
  name: 'filterSpecsByGroup'
})
export class FilterSpecsByGroupPipe implements PipeTransform {

  constructor(private groupByValuesPipe: GroupByValuesPipe) {
  }

  transform(specLines: SpecLineModel[], properties: PropertyQuery[], group: string, skipGroup: boolean = false): SpecLineModel[] {
    const filteredValues = specLines.filter(specLine => {
      if (skipGroup) {
        return true;
      }
      if (specLine.GroupClv) {
        return specLine.GroupClv === group;
      }
      if (specLine.PropertyId) {
        const groupClv = properties.find(property => property.Id === specLine.PropertyId)?.GroupClv;
        if (!group) {
          return !groupClv
        }
        return groupClv === group;
      } else if (!group) {
        return true;
      }
      return false;
    });
    const groups = this.groupByValuesPipe.transform(filteredValues, 'PropertyId');

    groups.forEach(group => {
      group.sort((a, b) => {
        return !a.LanguageId ? -1 : 1;
      });
    });

    const sortedValues: SpecLineModel[] = [];
    groups.forEach(group => {
      group.forEach(element => sortedValues.push(element));
    });
    return sortedValues;
  }
}
